var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAngleLeftColor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 10,
    viewBox: "0 0 8 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.31056 9.68661C6.44909 9.68965 6.58514 9.64949 6.69977 9.57165C6.81441 9.4938 6.90195 9.38212 6.95021 9.25223C6.99847 9.12233 7.00506 8.98065 6.96907 8.84684C6.93307 8.71303 6.85628 8.59381 6.74936 8.50566L2.66993 5.01087L6.74936 1.51731C6.82332 1.46296 6.88526 1.39395 6.9313 1.31454C6.97734 1.23514 7.00649 1.14706 7.01692 1.05587C7.02735 0.964679 7.01884 0.872335 6.99193 0.784585C6.96501 0.696835 6.92027 0.615561 6.8605 0.545904C6.80073 0.476247 6.72722 0.419744 6.64457 0.379811C6.56193 0.33988 6.47193 0.317451 6.38021 0.313912C6.28849 0.310374 6.19703 0.325759 6.11156 0.359204C6.02608 0.392649 5.94844 0.443381 5.88348 0.508225L1.2129 4.50437C1.13956 4.56696 1.08066 4.64465 1.04027 4.7322C0.999888 4.81976 0.978974 4.91506 0.978974 5.01149C0.978974 5.10791 0.999888 5.20321 1.04027 5.29077C1.08066 5.37833 1.13956 5.45609 1.2129 5.51868L5.88348 9.51867C6.00146 9.62347 6.15279 9.68305 6.31056 9.68676V9.68661Z",
    fill: "#703CE5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAngleLeftColor);
export default __webpack_public_path__ + "static/media/angle-left-color.4570c206aee4a6dfc5e79876c0b1401e.svg";
export { ForwardRef as ReactComponent };